<!--sidebar-->
<c-sidebar #sidebar="cSidebar" class="d-print-none sidebar sidebar-fixed" id="sidebar" visible>
  <!-- <div class="sidebar-pattern"> -->


  <c-sidebar-brand [brandFull]="{
      src: 'assets/images/new-logo-adphc.svg',
     width:'100%',
      alt: 'CoreUI Logo'
    }" [brandNarrow]="{
      src: 'assets/images/new-logo-adphc.svg',
      width: 46,
      height: 46,
      alt: 'CoreUI Logo'
    }" routerLink="./" />

  <button toggle="visible" cHeaderToggler [cSidebarToggle]="sidebarId" class="">
    <img src="../../../assets/icons/ArrowsLeftRight.svg" alt="">
  </button>

  <ng-scrollbar pointerEventsMethod="scrollbar">
    <c-sidebar-nav [navItems]="navItems" dropdownMode="close" />
  </ng-scrollbar>
  <!-- <c-sidebar-toggler
    *ngIf="!sidebar.narrow"
    toggle="unfoldable"
    cSidebarToggle="sidebar"
  /> -->
  <!-- </div> -->
  <div position='sticky' class="text-white p-2" style="margin-top:30px;">
    <a class="text-white">Public Health Care</a>
    <span> &copy; Abu Dhabi</span>
  </div>
</c-sidebar>

<!--main-->
<div class="wrapper d-flex flex-column min-vh-100 dark:bg-transparent">
  <!--app-header-->
  <app-default-header class="mb-4 d-print-none header header-sticky" position="sticky" sidebarId="sidebar" />
  <!--app-body-->
  <div class="body flex-grow-1 px-3">
    <c-container fluid class="h-auto">
      <router-outlet />
    </c-container>
  </div>
  <!--app footer-->
  <app-default-footer position="sticky" />
</div>


<!-- <app-filter-sidebar *ngIf='isFilterSidebarOpen' /> -->